export enum NavigationBarSteps {
  SELECT_PLAN = "SELECT_PLAN",
  PERSONAL_DETAILS = "PERSONAL_DETAILS",
  ADDRESS_DETAILS = "ADDRESS_DETAILS",
  PAYMENT_METHOD = "PAYMENT_METHOD"
}